(function () {
  class ProductSpecs extends HTMLElement {
    connectedCallback() {
      this.data = this.parseData();
      if (!this.data) return;

      this.onVariantChange = this.onVariantChange.bind(this);
      this.onInputChange = this.onInputChange.bind(this);

      // Source fiable : le theme emet variant:change sur le formulaire produit,
      // avec bubbles: true et detail.variant.
      document.addEventListener('variant:change', this.onVariantChange);

      // Repli historique : lors du re-rendu partiel du bloc des boutons d'achat,
      // le theme ecrit la valeur dans l'input cache et emet un change. Delegue
      // sur document pour survivre au remplacement du noeud.
      document.addEventListener('change', this.onInputChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      document.removeEventListener('change', this.onInputChange);
    }

    parseData() {
      const script = this.querySelector('[data-pspec-variants]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.warn('[product-specs] donnees de variantes illisibles', error);
        return null;
      }
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (variant) this.update(variant.id);
    }

    onInputChange(event) {
      const target = event.target;
      if (target && target.name === 'id') this.update(target.value);
    }

    update(variantId) {
      const id = String(variantId);
      if (id === this.currentId) return;

      const values = this.data[id];
      if (!values) return;
      this.currentId = id;

      this.querySelectorAll('[data-pspec-value]').forEach((element) => {
        const key = element.getAttribute('data-pspec-value');
        if (!(key in values)) return;
        const value = values[key];
        element.textContent = value === null || value === '' ? '—' : value;
      });

      // Une cle absente du JSON compte ici comme vide et masque sa tuile, alors
      // que les cellules restent intactes. Le bandeau ne doit donc contenir que
      // des cles qui varient par variante, jamais une cle de product_scoped
      // (color, warranty) : sa tuile disparaitrait au premier changement.
      let visible = 0;
      this.querySelectorAll('[data-pspec-figure]').forEach((tile) => {
        const key = tile.getAttribute('data-pspec-figure');
        const value = values[key];
        const empty = value === undefined || value === null || value === '';
        tile.hidden = empty;
        if (!empty) visible += 1;
      });

      const band = this.querySelector('[data-pspec-figures]');
      if (band) {
        band.classList.toggle('pspec__numbers--single', visible < 2);
        band.hidden = visible === 0;
      }

      // Sans tuile, le separateur sous le bandeau n'a plus rien a separer.
      const divider = this.querySelector('[data-pspec-divider]');
      if (divider) divider.hidden = visible === 0;
    }
  }

  if (!customElements.get('product-specs')) {
    customElements.define('product-specs', ProductSpecs);
  }
})();
